import React from 'react'
import { Box, Button, Card, CardActions, CardContent, Paper, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import Grid from '@mui/material/Unstable_Grid2'
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined'
import PriceChangeIcon from '@mui/icons-material/PriceChange'
import MoneyIcon from '@mui/icons-material/Money'
import SignpostIcon from '@mui/icons-material/Signpost'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import PersonOffIcon from '@mui/icons-material/PersonOff'

const FinanceLandingPage: React.FC = () => {
  const history = useHistory()
  const goTo = (location: string): void => {
    history.push(location)
  }

  return (
    <>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Finance Team</Typography>
      </Box>
      <Paper>
        <Box sx={{ p: 4 }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

            <Grid xs={6}>
              <Card sx={{ mr: 4 }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Payments
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  {/* <Button startIcon={<SavingsIcon/>} color="primary" onClick={() => { goTo('/app/finance-area/statements') }}> */}
                  {/*  EFT Statements */}
                  {/* </Button> */}
                  {/* <Button startIcon={<PriceChangeIcon />} color="primary" onClick={() => { goTo('/app/finance-area/payments/wallet-payments') }}> */}
                  {/*  Cash Out Instructions */}
                  {/* </Button> */}
                  <Button startIcon={<PriceChangeIcon />} color="primary" onClick={() => { goTo('/app/finance-area/disbursements/batches') }}>
                    Disbursements
                  </Button>
                  <Button startIcon={<PriceChangeIcon />} color="primary" onClick={() => { goTo('/app/finance-area/disbursements/fees') }}>
                    Disbursement Fees
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid xs={6}>
              <Card sx={{ mr: 4 }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Distributions
                  </Typography>
                </CardContent>
                <CardActions disableSpacing>
                  <Button startIcon={<OfflineBoltOutlinedIcon />} color="primary" onClick={() => { goTo('/app/distributions/run') }}>
                    Weekly Distributions
                  </Button>
                  <Button startIcon={<MoneyIcon />} color="primary" onClick={() => { goTo('/app/adhoc-distributions/pending') }}>
                    Adhoc Distributions
                  </Button>
                  <Button startIcon={<SignpostIcon />} color="primary" onClick={() => { goTo('/app/distributions/emails') }}>
                    Email Notifications
                  </Button>
                </CardActions>
              </Card>
            </Grid>
            <Grid xs={6}>
            </Grid>
          </Grid>

          <Grid xs={6}>
            <Card sx={{ mr: 4 }}>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Currency Exchange
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <Button startIcon={<CurrencyExchangeIcon/>} color="primary"
                        sx={{ mr: 8 }}
                        onClick={() => { goTo('/app/finance-area/currency-exchange-instructions/create') }}>
                  Create Currency Exchange Instruction
                </Button>

                <Button startIcon={<CurrencyExchangeIcon/>} color="primary"
                        sx={{ mr: 8 }}
                        onClick={() => { goTo('/app/finance-area/currency-exchange-instructions/batches') }}>
                  Currency Exchange Instructions
                </Button>

                <Button startIcon={<CurrencyExchangeIcon/>} color="primary" onClick={() => { goTo('/app/finance-area/currency-exchange-orders') }}>
                  VALR Orders
                </Button>

                <Button startIcon={<MonetizationOnIcon />} color="primary" onClick={() => { goTo('/app/finance-area/currency-exchange-pairs') }}>
                  Currency Exchange Pairs
                </Button>

              </CardActions>
            </Card>
          </Grid>

          <Grid xs={6}>
            <Card sx={{ mr: 4, mt: 2 }}>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Reconciliation
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <Button startIcon={<ReceiptLongIcon />} color="primary" onClick={() => { goTo('/app/finance-area/journal-recons') }}>
                  Monthly Journal Reconciliation
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid xs={6}>
            <Card sx={{ mr: 4, mt: 2 }}>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Account Charges
                </Typography>
              </CardContent>
              <CardActions disableSpacing>
                <Button startIcon={<RequestQuoteIcon />} color="primary" onClick={() => { goTo('/app/finance-area/account-charges/run') }}>
                  Monthly Charge Run
                </Button>
                <Button startIcon={<PersonOffIcon />} color="primary" onClick={() => { goTo('/app/finance-area/account-charges/exclusions') }}>
                  Charge Run Exclusions
                </Button>
              </CardActions>
            </Card>
          </Grid>

        </Box>
      </Paper>
    </>
  )
}

export default FinanceLandingPage
